import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import Button from '../../Button';
import { SearchIcon } from '../../../../../assets';

type SearchInputProps = Omit<TextFieldProps, 'variant'>;
export function SearchInput(props: SearchInputProps) {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const onClickButton = (e: any) => {
    inputRef.current?.focus();
    props.onClick && props.onClick(e);
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <TextField
        fullWidth
        placeholder="Write to start search"
        variant="outlined"
        sx={(theme) => ({
          '& .MuiOutlinedInput-root': {
            // Dark background
            backgroundColor: theme.palette.background.paper,

            // White text
            color: theme.palette.common.black,

            // Rounded left corners only
            borderRadius: '8px 0 0 8px',

            // Gray border
            fieldset: { borderColor: '#555' },

            ...theme.applyStyles('dark', {
              color: theme.palette.common.white,
            }),
          },

          '& .MuiOutlinedInput-input': {
            height: '1.5rem',
            padding: 2,
          },
        })}
        inputRef={inputRef}
        {...props}
      />
      <Button
        variant="contained"
        sx={{
          borderRadius: '0 8px 8px 0', // Rounded right corners
          padding: 2,
          width: '7rem',
          fontSize: '1.5rem',
          height: '1.5rem',
          boxSizing: 'content-box',
        }}
        onClick={onClickButton}
      >
        <SearchIcon />
      </Button>
    </div>
  );
}

export default SearchInput;
